export default "__VITE_ASSET__RDgTRiPj__"